module.exports = 'query GetInstance($host:String!){instance(host:$host){config cms{homepage}id logo{url}name theme features}}'